import {
  REIUMBURSEMENT_TABS_DATA_REQUEST,
  REIUMBURSEMENT_TABS_DATA_SUCCESS,
  REIUMBURSEMENT_TABS_DATA_FAILURE,
  REIUMBURSEMENT_TABS_DATA_LOADING,
  REIUMBURSEMENT_APPEALS_TAB_DETAILS_DATA_REQUEST,
  REIUMBURSEMENT_APPEALS_TAB_DETAILS_DATA_SUCCESS,
  REIUMBURSEMENT_APPEALS_TAB_DETAILS_DATA_FAILURE,
  REIUMBURSEMENT_APPEALS_TAB_DETAILS_DATA_LOADING,
  REIUMBURSEMENT_RECONSIDERATION_TAB_DETAILS_DATA_REQUEST,
  REIUMBURSEMENT_RECONSIDERATION_TAB_DETAILS_DATA_SUCCESS,
  REIUMBURSEMENT_RECONSIDERATION_TAB_DETAILS_DATA_FAILURE,
  REIUMBURSEMENT_RECONSIDERATION_TAB_DETAILS_DATA_LOADING,
  REIUMBURSEMENT_TABS_DATA_DOP_FILTERS_REQUEST,
  REIUMBURSEMENT_TABS_DATA_DOP_FILTERS_SUCCESS,
  REIUMBURSEMENT_TABS_DATA_DOP_FILTERS_FAILURE,
  REIUMBURSEMENT_TABS_DATA_DOP_FILTERS_LOADING,
  REIUMBURSEMENT_TABS_NONPAYMENT_REQUEST,
  REIUMBURSEMENT_TABS_NONPAYMENT_SUCCESS,
  REIUMBURSEMENT_TABS_NONPAYMENT_FAILURE,
  REIUMBURSEMENT_TABS_NONPAYMENT_LOADING,
  REIUMBURSEMENT_TABS_POLLING_STARTED,
  REIUMBURSEMENT_TABS_POLLING_COMPLETED,
  REIUMBURSEMENT_TABS_POLLING_FAILED,
  REIUMBURSEMENT_TABS_POLLING_RESET
} from '../actionTypes';

export const fetchReiumbursementTabsData = (payload: any, highVolumeTinFlag: boolean) => ({
  type: REIUMBURSEMENT_TABS_DATA_REQUEST,
  payload,
  highVolumeTinFlag,
});

export const fetchReiumbursementTabsDataSuccess = (payload: any) => ({
  type: REIUMBURSEMENT_TABS_DATA_SUCCESS,
  payload,
});

export const fetchReiumbursementTabsDataError = (payload: any) => ({
  type: REIUMBURSEMENT_TABS_DATA_FAILURE,
  payload,
});

export const fetchReiumbursementTabsDataLoading = (payload: any) => ({
  type: REIUMBURSEMENT_TABS_DATA_LOADING,
  payload,
});

// Appeals Tab Details Data Action Types

export const fetchAppealsTabDetailsData = (payload: any, highVolumeTinFlag: boolean) => ({
  type: REIUMBURSEMENT_APPEALS_TAB_DETAILS_DATA_REQUEST,
  payload,
  highVolumeTinFlag,
});

export const fetchAppealsTabDetailsDataSuccess = (payload: any) => ({
  type: REIUMBURSEMENT_APPEALS_TAB_DETAILS_DATA_SUCCESS,
  payload,
});

export const fetchAppealsTabDetailsDataError = (payload: any) => ({
  type: REIUMBURSEMENT_APPEALS_TAB_DETAILS_DATA_FAILURE,
  payload,
});

export const fetchAppealsTabDetailsDataLoading = (payload: any) => ({
  type: REIUMBURSEMENT_APPEALS_TAB_DETAILS_DATA_LOADING,
  payload,
});

// Reconsideration Tab Details Data Action Types

export const fetchReconsiderationTabDetailsData = (payload: any, highVolumeTinFlag: boolean) => ({
  type: REIUMBURSEMENT_RECONSIDERATION_TAB_DETAILS_DATA_REQUEST,
  payload,
  highVolumeTinFlag,
});

export const fetchReconsiderationTabDetailsDataSuccess = (payload: any) => ({
  type: REIUMBURSEMENT_RECONSIDERATION_TAB_DETAILS_DATA_SUCCESS,
  payload,
});

export const fetchReconsiderationTabDetailsDataError = (payload: any) => ({
  type: REIUMBURSEMENT_RECONSIDERATION_TAB_DETAILS_DATA_FAILURE,
  payload,
});

export const fetchReconsiderationTabDetailsDataLoading = (payload: any) => ({
  type: REIUMBURSEMENT_RECONSIDERATION_TAB_DETAILS_DATA_LOADING,
  payload,
});

// DOP Filters Data Action Types

export const fetchDopFiltersData = (payload: any) => ({
  type: REIUMBURSEMENT_TABS_DATA_DOP_FILTERS_REQUEST,
  payload,
});
export const fetchDopFiltersDataSuccess = (payload: any) => ({
  type: REIUMBURSEMENT_TABS_DATA_DOP_FILTERS_SUCCESS,
  payload,
});
export const fetchDopFiltersDataError = (payload: any) => ({
  type: REIUMBURSEMENT_TABS_DATA_DOP_FILTERS_FAILURE,
  payload,
});
export const fetchDopFiltersDataLoading = (payload: any) => ({
  type: REIUMBURSEMENT_TABS_DATA_DOP_FILTERS_LOADING,
  payload,
});
export const reimbursementPollingStarted = (url?: any) => ({
  type: REIUMBURSEMENT_TABS_POLLING_STARTED,
  url
});

export const reimbursementPollingCompleted = (url?: any) => ({
  type: REIUMBURSEMENT_TABS_POLLING_COMPLETED,
  url
});

const serializePollingError = (error: any) => {
  if (!error) return null;
  if (typeof error === 'string') return error;

  return {
    name: error.name || 'Error',
    message: error.message || 'Unknown error',
    stack: error.stack || null,
  };
};

export const reimbursementPollingError = (error: any) => ({
  type: REIUMBURSEMENT_TABS_POLLING_FAILED,
  payload: serializePollingError(error),
});

export const reimbursementPollingReset = () => ({
  type: REIUMBURSEMENT_TABS_POLLING_RESET
});


// Non-Payment DOP Filters Data Action Types

export const fetchNonPaymentTabData = (payload: any, highVolumeTinFlag: boolean) => ({
  type: REIUMBURSEMENT_TABS_NONPAYMENT_REQUEST,
  payload,
  highVolumeTinFlag,
});

export const fetchNonPaymentTabDataSuccess = (payload: any) => ({
  type: REIUMBURSEMENT_TABS_NONPAYMENT_SUCCESS,
  payload,
});

export const fetchNonPaymentTabDataError = (payload: any) => ({
  type: REIUMBURSEMENT_TABS_NONPAYMENT_FAILURE,
  payload: payload instanceof Error ? payload.message : payload,
});

export const fetchNonPaymentTabDataLoading = (payload: any) => ({
  type: REIUMBURSEMENT_TABS_NONPAYMENT_LOADING,
  payload,
});